// extracted by mini-css-extract-plugin
module.exports = {"vatInvoiceForm":"ApprovalContent_vatInvoiceForm__3e_Eq","emailConfirm":"ApprovalContent_emailConfirm__2_KbA"};